import { render, staticRenderFns } from "./registerStep1.vue?vue&type=template&id=43b0908a&"
import script from "./registerStep1.vue?vue&type=script&lang=js&"
export * from "./registerStep1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "registerStep1.vue"
export default component.exports